import { Header } from "../../../Components/Index";
import ServiceCatalogCard from "./ServiceCatalogCard";
import ServiceDetailsModal from "./ServiceDetailsModal";
import ServiceOptionRow from "./ServiceOptionRow";
import ServiceTwoIcon from "./ServiceTwoIcon";
import TirePositionPicker from "./TirePositionPicker";

/** Presentation-only view for the service selection flow. */
export default function ServiceTwoView({
  showDetails,
  loading,
  loadError,
  catalog,
  selectedServiceKeys,
  selectedServices,
  selectedCategories,
  categoryDetails,
  selectedIds,
  activeCategory,
  submitError,
  onToggleService,
  onRetry,
  onBackToCatalog,
  onAction,
  onOpenDetails,
  onToggleTire,
  onTireAction,
  onContinueToDetails,
  onConfirm,
  onSaveDetails,
  onRemoveDetails,
  onCloseDetails,
  backRoute = "/PlateCapture",
}) {
  return (
    <>
      <Header
        hideR=""
        LinkR={showDetails ? "" : backRoute}
        onStartClick={showDetails ? onBackToCatalog : undefined}
        Text={showDetails ? "جزئیات سرویس‌ها" : "انتخاب سرویس‌ها"}
      />
      <main
        className={`service-picker${showDetails ? " is-detail-view" : ""}`}
        dir="rtl"
      >
        {loading ? (
          <div className="service-picker__loading" role="status">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <span key={item} />
            ))}
          </div>
        ) : loadError ? (
          <div className="service-picker__state" role="alert">
            <ServiceTwoIcon name="warning" />
            <b>فهرست سرویس‌ها دریافت نشد</b>
            <p>{loadError}</p>
            <button type="button" onClick={onRetry}>
              تلاش دوباره
            </button>
          </div>
        ) : !showDetails ? (
          <Catalog
            catalog={catalog}
            selectedServiceKeys={selectedServiceKeys}
            onToggle={onToggleService}
          />
        ) : (
          <Details
            catalog={selectedServices}
            selectedCategories={selectedCategories}
            categoryDetails={categoryDetails}
            onAction={onAction}
            onOpenDetails={onOpenDetails}
            onToggleTire={onToggleTire}
            onTireAction={onTireAction}
          />
        )}
        {!loading && !loadError && (
          <ServiceFooter
            showDetails={showDetails}
            selectedIds={selectedIds}
            selectedServiceKeys={selectedServiceKeys}
            submitError={submitError}
            onContinue={onContinueToDetails}
            onConfirm={onConfirm}
          />
        )}
      </main>
      {activeCategory && (
        <ServiceDetailsModal
          category={activeCategory}
          initialValue={categoryDetails[activeCategory.id]}
          onSave={onSaveDetails}
          onRemove={() => onRemoveDetails(activeCategory)}
          onClose={onCloseDetails}
        />
      )}
    </>
  );
}

function Catalog({ catalog, selectedServiceKeys, onToggle }) {
  return (
    <section className="service-catalog" aria-label="دسته‌بندی سرویس‌ها">
      <div className="service-catalog__grid">
        {catalog.map((service) => (
          <ServiceCatalogCard
            key={service.key}
            service={service}
            selected={selectedServiceKeys.includes(service.key)}
            onClick={() => onToggle(service.key)}
          />
        ))}
      </div>
    </section>
  );
}

function Details({
  catalog,
  selectedCategories,
  categoryDetails,
  onAction,
  onOpenDetails,
  onToggleTire,
  onTireAction,
}) {
  return (
    <section className="service-detail-page">
      <div className="selected-services-list">
        {catalog.map((service) => (
          <section className="selected-service-section" key={service.key}>
            <header>
              <span>
                <ServiceTwoIcon name={service.icon} />
              </span>
              <div>
                <h2>{service.title}</h2>
                <p>{service.description}</p>
              </div>
              <b>
                {service.options
                  .filter((item) => selectedCategories[item.id])
                  .length.toLocaleString("fa-IR")}
              </b>
            </header>
            {service.kind === "tires" ? (
              <TirePositionPicker
                options={service.options}
                selectedCategories={selectedCategories}
                onToggle={onToggleTire}
                onSetAction={(action) => onTireAction(service, action)}
                onOpen={onOpenDetails}
              />
            ) : (
              <div className="service-options">
                {service.options.map((item) => (
                  <ServiceOptionRow
                    key={item.id}
                    item={item}
                    action={selectedCategories[item.id]}
                    details={categoryDetails[item.id]}
                    onAction={(action) => onAction(item, action)}
                    onOpen={() => onOpenDetails(item)}
                  />
                ))}
              </div>
            )}
          </section>
        ))}
      </div>
    </section>
  );
}

function ServiceFooter({
  showDetails,
  selectedIds,
  selectedServiceKeys,
  submitError,
  onContinue,
  onConfirm,
}) {
  return showDetails ? (
    <footer className="service-picker__footer service-picker__footer--detail">
      <div>
        <b>{selectedIds.length.toLocaleString("fa-IR")} سرویس</b>
        <small>جزئیات تکمیل شده</small>
      </div>
      <button type="button" onClick={onConfirm} disabled={!selectedIds.length}>
        تأیید و انتخاب مشتری <ServiceTwoIcon name="check" />
      </button>
      {submitError && <p role="alert">{submitError}</p>}
    </footer>
  ) : (
    <footer className="service-picker__footer">
      <div>
        <b>{selectedServiceKeys.length.toLocaleString("fa-IR")} دسته</b>
        <small>برای ادامه انتخاب شده</small>
      </div>
      <button
        type="button"
        onClick={onContinue}
        disabled={!selectedServiceKeys.length}
      >
        ادامه و تکمیل جزئیات <ServiceTwoIcon name="arrow" />
      </button>
    </footer>
  );
}
